import { render, staticRenderFns } from "./ConsultantDetails.vue?vue&type=template&id=498a007e&scoped=true&"
import script from "./ConsultantDetails.vue?vue&type=script&lang=js&"
export * from "./ConsultantDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantDetails.vue?vue&type=style&index=0&id=498a007e&scoped=true&lang=css&"
import style1 from "./ConsultantDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498a007e",
  null
  
)

export default component.exports